import { APP_COLORS } from "../../constants/styles";
import { parseWithRemoveBrTagsFromBody } from "../../utils/articleHelpers";
import ArrowSvg from "../FeatureTiles3x/ArrowSvg";
import { Link } from "react-router-dom";

import "./FeatureTiles4x.css";
import { useGetLink } from "../../utils/useOpenLink";

function FeatureTiles4x({ contents, body, colors: colorObj }) {
    const parseBody = parseWithRemoveBrTagsFromBody(body);
    const { getLink } = useGetLink();

    return (
        <section className=" px-4 max-w-7xl mx-auto section_FT4x" style={APP_COLORS(colorObj)}>
            {parseBody && <h2 className=" text-2xl font-medium header_FT4x">{parseBody}</h2>}

            <div
                className=" grid grid-cols-1 max-md:grid-cols-2 md:grid-cols-4 wrapper_content_FT4x"
                data-aos="fade-up"
            >
                {contents?.map(
                    ({ content_image, heading, id, body: contentsBody, content_reference }) => (
                        <Link
                            to={getLink(content_reference)}
                            key={id}
                            className="group relative aspect-square-ratio rounded-xl overflow-hidden text-accent_color4 
                            cursor-pointer md:min-h-96 link_color"
                        >
                            <img
                                src={content_image.src}
                                alt={content_image.alt}
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[rgba(0,0,0,0.52)] group-hover:to-[rgba(0,0,0,0.7)] transition-colors duration-500 md:p-5 max-md:p-[14px] flex flex-col justify-end">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <h3 className="font-semibold header_title_FT4x">
                                            {heading}
                                        </h3>
                                        <span className="font-medium text_title_FT4x">
                                            {parseWithRemoveBrTagsFromBody(contentsBody).length > 95
                                                ? parseWithRemoveBrTagsFromBody(contentsBody).slice(
                                                      0,
                                                      95,
                                                  ) + " ..."
                                                : parseWithRemoveBrTagsFromBody(contentsBody)}
                                        </span>
                                    </div>
                                    <div className="flex items-center h-full transition-transform duration-300 group-hover:-rotate-45">
                                        <ArrowSvg />
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ),
                )}
            </div>
        </section>
    );
}

export default FeatureTiles4x;
